import React from 'react';

/**
 * Legacy fallback Tailwind class map for Primal TCG rarities.
 * Used when no game config is available.
 */
var LEGACY_RARITY_CLASSES = {
  'Common': 'tw-bg-gray-200 dark:tw-bg-gray-700 tw-text-gray-700 dark:tw-text-gray-300',
  'Uncommon': 'tw-bg-green-100 dark:tw-bg-green-900/40 tw-text-green-700 dark:tw-text-green-400',
  'Legacy Uncommon': 'tw-bg-green-100 dark:tw-bg-green-900/40 tw-text-green-700 dark:tw-text-green-400',
  'Rare': 'tw-bg-blue-100 dark:tw-bg-blue-900/40 tw-text-blue-700 dark:tw-text-blue-400',
  'Super Rare': 'tw-bg-yellow-100 dark:tw-bg-yellow-900/40 tw-text-yellow-700 dark:tw-text-yellow-400',
  'Legendary Rare': 'tw-bg-purple-100 dark:tw-bg-purple-900/40 tw-text-purple-700 dark:tw-text-purple-400',
  'Secret Rare': 'tw-text-white secret-rare-badge',
  'Alternate Art': 'tw-bg-brand-gold/20 tw-text-brand-gold',
  'Legacy Common': 'tw-bg-gray-200 dark:tw-bg-gray-700 tw-text-gray-700 dark:tw-text-gray-300',
  'Legacy Super Rare': 'tw-bg-yellow-100 dark:tw-bg-yellow-900/40 tw-text-yellow-700 dark:tw-text-yellow-400',
};

/**
 * Render a rarity badge using the Tailwind class map.
 *
 * @param {string} rarity - Rarity name (e.g. "Common", "Rare")
 * @param {Array|null} raritiesConfig - Unused, kept for API compatibility
 * @returns {React.Element|null}
 */
export function renderRarityBadge(rarity, raritiesConfig) {
  if (!rarity) return null;

  var cls = LEGACY_RARITY_CLASSES[rarity] || 'tw-bg-gray-200 dark:tw-bg-gray-700 tw-text-gray-700 dark:tw-text-gray-300';
  return (
    <span className={'tw-text-xs tw-font-semibold tw-px-2 tw-py-0.5 tw-rounded-full tw-whitespace-nowrap ' + cls}>
      {rarity}
    </span>
  );
}

/**
 * Get hex color for a rarity from game config. Used in admin/charts.
 *
 * @param {string} rarity - Rarity name
 * @param {Array|null} raritiesConfig - Game's rarities array
 * @returns {string} Hex color
 */
export function getRarityColor(rarity, raritiesConfig) {
  if (raritiesConfig && raritiesConfig.length > 0) {
    for (var i = 0; i < raritiesConfig.length; i++) {
      if (raritiesConfig[i].name === rarity) {
        return raritiesConfig[i].color;
      }
    }
  }
  // Legacy fallback hex colors
  var legacyHex = {
    'Common': '#6B7280',
    'Uncommon': '#10B981',
    'Rare': '#3B82F6',
    'Super Rare': '#8B5CF6',
    'Legendary Rare': '#EAB308',
    'Secret Rare': '#EF4444',
    'Alternate Art': '#D4A843',
    'Legacy Common': '#9CA3AF',
    'Legacy Super Rare': '#7C3AED',
    'Primal Rare': '#D4A843',
    'Promo': '#EF4444',
  };
  return legacyHex[rarity] || '#6B7280';
}
